import React, { useMemo } from "react";

import PlatformFilterOperator from "@mapmycustomers/shared/enum/PlatformFilterOperator";
import {
  Company,
  Deal,
  EntitiesSupportingDataView,
  EntityType,
  Person,
} from "@mapmycustomers/shared/types/entity";
import PlatformFilterModel from "@mapmycustomers/shared/types/viewModel/platformModel/PlatformFilterModel";

import DataView from "@app/component/DataView";
import DataViewEntityTypeCount from "@app/component/DataView/type/DataViewEntityTypeCount";

import styles from "./DataViewWrapper.module.scss";

interface Props {
  onHide: () => void;
  selectedEntities: Set<EntitiesSupportingDataView>;
}

const DataViewWrapper: React.FC<Props> = ({ onHide, selectedEntities }) => {
  const [dataViewFilter, entityTypeRecordsCount]: [PlatformFilterModel, DataViewEntityTypeCount] =
    useMemo(() => {
      const companyIds: Company["id"][] = [],
        personIds: Person["id"][] = [],
        dealIds: Deal["id"][] = [];
      Array.from(selectedEntities).forEach(({ id, entity }) => {
        (entity === EntityType.COMPANY
          ? companyIds
          : entity === EntityType.PERSON
          ? personIds
          : dealIds
        ).push(id);
      });
      return [
        {
          entities: {
            ...(companyIds.length > 0
              ? {
                  [EntityType.COMPANY]: {
                    $and: [{ id: { [PlatformFilterOperator.CONTAINS]: companyIds } }],
                  },
                }
              : {}),
            ...(personIds.length > 0
              ? {
                  [EntityType.PERSON]: {
                    $and: [{ id: { [PlatformFilterOperator.CONTAINS]: personIds } }],
                  },
                }
              : {}),
            ...(dealIds.length > 0
              ? {
                  [EntityType.DEAL]: {
                    $and: [{ id: { [PlatformFilterOperator.CONTAINS]: dealIds } }],
                  },
                }
              : {}),
          },
        },
        {
          [EntityType.COMPANY]: companyIds.length,
          [EntityType.DEAL]: dealIds.length,
          [EntityType.PERSON]: personIds.length,
        },
      ];
    }, [selectedEntities]);

  return (
    <DataView
      className={styles.container}
      entityTypeRecordsCount={entityTypeRecordsCount}
      filter={dataViewFilter}
      hideTabs
      onHide={onHide}
      totalCount={selectedEntities.size}
    />
  );
};

export default DataViewWrapper;
